/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, ButtonBase, Grid, Typography} from "@mui/material";
import {Menu, QrCode} from "@mui/icons-material";
import {useContext, useEffect, useState} from "react";
import {useAnimate} from "framer-motion";
import IconoAvatarPerfil from "./SubComponentes/IconoAvatarPerfil";
import {useMediaQuery} from "@mui/system";
import {theme} from "../../Tema";
import {reducirHash} from "../../CodigoCliente/Funciones/reducirHash";
import {usuarioContext} from "../../App";
import {copiarPortapapeles} from "../../CodigoCliente/Funciones/copiarPortapapeles";
import {obtenerLinkReferido} from "../../CodigoCliente/Funciones/obtenerLinkReferido";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";

const Barra = ({setOpen, open, seccionesPerfil}) => {
    const cData = useContext(usuarioContext)
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const [navegando, setNavegando] = useState(false)
    const [scope, animate] = useAnimate()
    const [opaco, setOpaco] = useState(1)
    const [openPerfil, setOpenPerfil] = useState(false)
    const [openPerfilNotificacion, setOpenPerfilNotificaciones] = useState(false)
    ////////////////////////////////////
    const {Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: ''})


    const copiar = (codigo) => {

        let obj = copiarPortapapeles(obtenerLinkReferido({codigo: codigo}))

        if (obj) {
            terminar({aviso: 'Link copiado'})
        } else {
            terminar({
                aviso: 'Tu dispositivo no permire esta accion, copia el tu codigo de cliente y envialo a tu referido',
                variante: 'error'
            })
        }

    }


    useEffect(() => {


        window.addEventListener('scroll', (e) => {
            if (window.scrollY > 50 && !navegando) {
                setNavegando(true)
            } else if (window.scrollY < 50) {
                setNavegando(false)
            }

        });


        if (scope.current && masSM) {
            setOpaco(0)
            animate(scope.current, {x: -200, transitionDuration: 0})
            setTimeout(() => {
                setOpaco(1)
                if (scope.current) {
                    animate(scope.current, {x: 1, transitionDuration: 0})
                }

            }, 500)
        }


    }, [open]);
    return (
        <Grid
            container
            size={12}
            alignItems={'center'}
            sx={{
                px: masSM ? 4 : 3,
                py: 2,
                boxShadow: navegando ? 3 : 0,
                position: 'fixed',
                top: '0%',
                pr: open && masSM ? 36 : !masSM ? 1 : 13,
                borderBottom: 0.5,
                borderColor: '#ffffff50',
                background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
                backdropFilter: 'blur(5px)',
                color: '#fff',
            }}
            spacing={2}
        >

            <Avisos/>

            <Grid size={{xs: 1, sm: 1, md: 1}}>
                <ButtonBase
                    onClick={() => setOpen((e) => !e)}
                >
                    <Menu/>
                </ButtonBase>

            </Grid>

            <Grid container size={{xs: 0, sm: 4, md: 5}}
                  justifyContent={'flex-end'}
            >


            </Grid>

            <Grid container size={{xs: 6, sm: 4, md: 3}}
                  justifyContent={'flex-end'}
                  sx={{pl: 1}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        borderRadius: 1,
                        border: 0.5,
                        borderColor: 'rgba(255, 255, 255, 0.50)',
                        background: 'linear-gradient(90deg, rgba(31, 125, 254, 0.20) 0%, rgba(128, 182, 255, 0.20) 100%)',
                        backdropFilter: 'blur(5px)',
                        color: '#fff',
                        p: 1
                    }}
                >

                    {!sCell &&
                        <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <QrCode/>
                        </Grid>
                    }

                    <Grid container size={{xs: 6, sm: 4, md: 4}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? 0.5 : 0, pl: sCell ? 1 : 0}}>
                        <Typography>{cData.usuario.codigo ? reducirHash({hash: cData.usuario.codigo}) : ''}</Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Button
                            onClick={() => copiar(cData.usuario.codigo)}
                            fullWidth
                            sx={{fontSize: 12, px: 1, py: 0.6}}>{sCell ? 'Copiar' : 'Copiar Link'}</Button>
                    </Grid>


                </Grid>

            </Grid>

            <Grid
                ref={scope}
                container size={{xs: 4, sm: 3, md: 3}} justifyContent={'flex-end'} justifyItems={'center'}
                sx={{
                    opacity: opaco,
                    pr: (openPerfil || openPerfilNotificacion) && masSM ? 1.7 : 0,

                }}

            >


                <IconoAvatarPerfil openPerfil={openPerfil} setOpenPerfil={setOpenPerfil}
                                   seccionesPerfil={seccionesPerfil}/>


            </Grid>


        </Grid>
    )

}
export default Barra